import { reactive } from 'vue'
import { Router } from 'vue-router'
import { QuestionsStore } from '@/stores/common/questions'
import { ComputableObject } from '@/types/global'
import { IQuestionsFiveState } from '@/types/common/questions'

import { routerConstants } from '@/constants/routers/common'
const { PATH } = routerConstants.LOCATION

export const useStates = (store: QuestionsStore): IQuestionsFiveState => {
  return reactive<ComputableObject<IQuestionsFiveState>>({
    isLoading: Object.keys(store.state.groupedPrefs).length === 0,
  })
}

export const useActions = (store: QuestionsStore, router: Router) => {
  /**
   * 回答選択
   * @param value
   */
  const handleInput = (value: string): void => {
    store.setInputPref(value)
    router.push({ path: PATH.QUESTIONS_RESULT, query: { ...store.state.inputs } })
  }

  return {
    handleInput: handleInput,
  }
}
